import { currencyString } from '@sales-center/common'
import Grid from '@mui/material/Grid'
import * as React from 'react'
import { useData } from './hooks'
import { Container, Value } from './styled'
import { InfoTooltip } from '@sales-center/components'
import { useLocalizationEnabled } from '@user/store/tenantFeatures/hooks/useLocalizationEnabled'

export function SummaryContents() {
  const {
    discounts,
    first,
    initial,
    initialWithTax,
    recurring,
    subsequent,
    tax,
    monthlyPayment,
    gstHstTaxes,
    pstQstTaxes,
  } = useData()

  const isCanadianTax = useLocalizationEnabled()
  const totalInitialPrice = currencyString(initial)
  const totalInitialPriceWithTax = currencyString(initialWithTax)
  const totalRecurringPrice = currencyString(recurring)
  const firstYearTotal = currencyString(first)
  const subsequentYearTotal = currencyString(subsequent)
  const discountTotal = currencyString(discounts)
  const totalSalesTax = currencyString(tax)
  const monthlyPaymentTotal = currencyString(monthlyPayment)
  return (
    <Container>
      <Grid container flexDirection="column">
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Total Initial Price</Grid>
          <Value item>${totalInitialPrice}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Total Initial Price w/ Tax</Grid>
          <Value item>${totalInitialPriceWithTax}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Total Recurring Price</Grid>
          <Value item>${totalRecurringPrice}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>First Year Total</Grid>
          <Value item>${firstYearTotal}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Subsequent Year Total</Grid>
          <Value item>${subsequentYearTotal}</Value>
        </Grid>
        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>Discounts</Grid>
          <Value item>${discountTotal}</Value>
        </Grid>

        {(!isCanadianTax || tax > 0) && (
          <Grid
            container
            item
            flexDirection="row"
            justifyContent="space-between"
          >
            <Grid item>Total Sales Tax</Grid>
            <Value item>${totalSalesTax}</Value>
          </Grid>
        )}

        {isCanadianTax && (
          <>
            {Object.entries(gstHstTaxes).map(
              ([label, taxAmount]) =>
                taxAmount > 0 && (
                  <Grid
                    container
                    item
                    flexDirection="row"
                    justifyContent="space-between"
                    key={label}
                  >
                    <Grid item>{label}</Grid>
                    <Value item>${currencyString(taxAmount)}</Value>
                  </Grid>
                ),
            )}

            {Object.entries(pstQstTaxes).map(
              ([label, taxAmount]) =>
                taxAmount > 0 && (
                  <Grid
                    container
                    item
                    flexDirection="row"
                    justifyContent="space-between"
                    key={label}
                  >
                    <Grid item>{label}</Grid>
                    <Value item>${currencyString(taxAmount)}</Value>
                  </Grid>
                ),
            )}
          </>
        )}

        <Grid container item flexDirection="row" justifyContent="space-between">
          <Grid item>
            Monthly Payment{' '}
            <InfoTooltip
              infoText="This displays the annual total of all recurring services plus tax divided by 12"
              tooltipPlacement="right"
              //className={classes.info}
            />
          </Grid>
          <Value item>${monthlyPaymentTotal}</Value>
        </Grid>
      </Grid>
    </Container>
  )
}
